import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import PlanTrip from "../components/PlanTrip";
import AboutMain from "../images/about/about-main.jpg";
import Box1 from "../images/about/icon1.png";
import Box2 from "../images/about/icon2.png";
import Box3 from "../images/about/icon3.png";

function About() {
  return (
    <>
      <section className="about-page">
        <HeroPages name="About" />
        <div className="container">
          <div className="about-main">
            <img
              className="about-main__img"
              src={AboutMain}
              alt="car-renting"
            />
            <div className="about-main__text">
              <h3>À propos de l’entreprise</h3>
              <h2>Démarrez le moteur… et votre aventure commence</h2>
              <p>
                Chez Librauto, nous mettons tout en œuvre pour vous offrir une expérience de
                location simple, rapide et agréable. Que ce soit pour un déplacement
                professionnel, un voyage en famille ou une escapade improvisée, nous vous
                accompagnons avec des véhicules fiables et un service de qualité.
                Votre aventure commence dès que vous tournez la clé.
              </p>

              <div className="about-main__text__icons">
                <div className="about-main__text__icons__box">
                  <img src={Box1} alt="car-icon" />
                  <span>
                    <h4>20</h4>
                    <p>Type de véhicule</p>
                  </span>
                </div>
                <div className="about-main__text__icons__box">
                  <img src={Box2} alt="car-icon" />
                  <span>
                    <h4>5</h4>
                    <p>Lieu de prise en charge</p>
                  </span>
                </div>
{/*                <div className="about-main__text__icons__box">
                  <img src={Box3} alt="car-icon" className="last-fk" />
                  <span>
                    <h4>75</h4>
                    <p>Repair Shop</p>
                  </span>
                </div>*/}
              </div>
            </div>
          </div>
          <PlanTrip />
        </div>
      </section>
      <div className="book-banner">
        <div className="book-banner__overlay"></div>
        <div className="container">
          <div className="text-content">
            <h2>Reservez votre véhicule en nous contactant</h2>
            <span>
              <i className="fa-solid fa-phone"></i>
              <h3>06 64 19 87 59</h3>
            </span>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default About;
